import Form from './Form';
export { default as Field } from './Field';
// import Item from './FormItem'

// type InternalFormType = typeof InternalForm
// interface FormInterface extends InternalFormType {
//   // useForm: typeof useForm;
//   Item: typeof Item
//   // List: typeof List;
//   // ErrorList: typeof ErrorList;
//   // Provider: typeof FormProvider;
// }

// const Form = InternalForm as FormInterface
// Form.Item = Item

// export { default as Label } from './Label'
export default Form;
